<template>
  <div class="login-page">
    <!--    <div class="page-head-container">-->
    <!--      <PageHead pageName="登录"/>-->
    <!--    </div>-->
    <input
      style="visivle: hidden; width: 0; height: 0; display: inline-block;border: none;"
      type="text"
      value
    />
    <input
      style="visivle: hidden; width: 0; height: 0; display: inline-block;border: none;"
      type="password"
      value
    />
    <div class="form-area-container">
      <div class="tab-container">
        <span
          class="tab-item"
          :class="{'current-tab': currentTab === '1'}"
          @click="handleTabClick('1')"
        >快捷登录</span>
        <span
          class="tab-item"
          :class="{'current-tab': currentTab === '2'}"
          @click="handleTabClick('2')"
        >账号密码登录</span>
      </div>
      <div class="form-area" v-if="currentTab === '1'">
        <div>
          <Input
            placeholder="手机号"
            maxlength="11"
            name="phone"
            v-model="phone"
            :error="phoneError"
            @input="handlePhoneInput"
          />
        </div>
        <div>
          <Input
            maxlength="4"
            ref="smsCodeInput"
            placeholder="短信验证码"
            name="smsCode"
            v-model="smsCode"
            :error="smsCodeError"
            @input="handleSmsCodeInput"
            @keyup="handleSmsCodeKeyUp"
          />
          <span class="get-smscode">
            <Countdown :onClick="handleSmsCodeClick" text="获取验证码" />
          </span>
        </div>

        <div v-if="showImgCode">
          <Input
            placeholder="图片验证码"
            maxlength="4"
            name="imgCode"
            v-model="imgCode"
            :onChange="handleFieldChange"
            @input="handleImgCodeInput"
            requiredText="请输入图片验证码"
            :error="imgCodeError"
            @keyup="handleImgCodeKeyUp"
          />
          <span class="get-imgCode">
            <img :src="imgCodeUrl" @click="refreshImgCode" />
          </span>
        </div>
      </div>

      <div class="form-area" v-if="currentTab === '2'">
        <div>
          <Input
            placeholder="手机号/邮箱/用户名"
            name="accountName"
            v-model="accountName"
            :error="accountError"
            @input="handleAccountInput"
          />
        </div>
        <div>
          <Input
            :type=" showPassword ? 'text' : 'password'"
            placeholder="密码"
            name="password"
            v-model="password"
            :error="passwordError"
            @input="handlePasswordInput"
            @keyup="handlePasswordKeyUp"
          />
          <img
            :src="showPassword ? visibleImg : invisibleImg"
            @click="showPassword = !showPassword"
            class="eye-img"
          >
        </div>
        <div v-if="showImgCode">
          <Input
            maxlength="4"
            placeholder="图片验证码"
            name="imgCode"
            v-model="imgCode"
            :error="imgCodeError"
            @input="handleImgCodeInput"
            @keyup="handleImgCodeKeyUp"
          />
          <span class="get-imgCode">
            <img :src="imgCodeUrl" @click="refreshImgCode" />
          </span>
        </div>
      </div>

      <div class="operate-container">
        <div class="remember">
          <input ref="remember" type="checkbox" name="remember" @change="handleRememberChange" />
          <label for="remember">记住登录</label>
          <span class="forget-password-btn" @click="handleClickForgetPasswordBtn">忘记密码?</span>
        </div>
        <div class="button">
          <Button text="登录" :onClick="handleLogin"></Button>
        </div>
        <div class="button">
          <span class="register-btn" @click="handleRegister">注册</span>
        </div>
      </div>

      <div class="qr-container" v-if="qrVisible">
        <div>
          <img :src="wlQr" alt class="wl-app-qr" />
          <div class="qr-tip">
            <p>您好，司机朋友</p>
            <p>我们开发了专属于您的APP</p>
            <p>请扫描二维码下载</p>
          </div>
          <div class="close-qr-btn-container">
            <span class="close-qr-btn" @click="hideQR">关闭二维码</span>
          </div>
        </div>
      </div>
    </div>

    <iframe
      v-if="isLoginSuccess"
      :src="hbgangxinDomain"
      frameborder="0"
      width="0"
      height="0"
      style="border: none; padding: 0; margin: 0;"
    ></iframe>
  </div>
</template>
<script>
import Input from '@/components/Input/index.vue'
import Button from '@/components/Button/index.vue'
import Message from '@/components/Message'
// import PageHead from '@/components/PageHead/index.vue'
import Countdown from '@/components/Countdown/index.vue'
import api from '@/api'
import session from '@/utils/session.js'
import { setCookie } from '@/utils/cookie'
import env from '@/utils/env.js'
import { WL_APP_QR } from '@/config';

import visibleImg from '@/assets/visible.png'
import invisibleImg from '@/assets/invisible.png'

export default {
  name: 'login-mini',
  data() {
    return {
      visibleImg,
      invisibleImg,
      showPassword: false,
      currentTab: '1',
      phone: '',
      wlQr: WL_APP_QR,
      smsCode: '',
      imgCode: '',
      rememberMe: false,

      imgCodeUrl: '/api/v1/randCode',

      accountName: '',
      password: '',

      showImgCode: localStorage.getItem('showImgCode_mini') === 'yes',
      phoneError: '',
      smsCodeError: '',
      imgCodeError: '',
      accountError: '',
      passwordError: '',

      qrVisible: false,

      isLoginSuccess: false,
      hbgangxinDomain: ''
    }
  },
  created() {
      setTimeout(() => {
      let baseTitle = JSON.parse(localStorage.getItem('WEB_INFO')).title || '';
      document.title = `${baseTitle}登录`;
    }, 500);
  },
  methods: {
    refreshImgCode() {
      this.imgCodeUrl = this.imgCodeUrl.split('?')[0] + '?v=' + Math.random()
    },
    reset() {
      this.phone = localStorage.getItem('sso_spa_login_mini_phone') || ''
      this.smsCode = ''
      this.accountName = localStorage.getItem('sso_spa_login_mini_accountName') || ''
      this.password = localStorage.getItem('sso_spa_login_mini_password') || ''
      this.imgCode = ''
      
      // this.phone = ''
      // this.smsCode = ''
      // this.accountName = ''
      // this.password = ''
      // this.imgCode = ''
    },
    resetError() {
      this.phoneError = ''
      this.smsCodeError = ''
      this.imgCodeError = ''
      this.accountError = ''
      this.passwordError = ''
    },
    handleTabClick(tabKey) {
      this.reset()
      this.currentTab = tabKey
      this.resetError()
    },
    /**
     * 跳转注册
     */
    handleRegister() {
      window.parent.location.href = `//${location.host}/#/register?redirect_url=${this.$route.query.serviceURL}&platform_code=${this.$route.query.client_id}`
    },
    handleClickForgetPasswordBtn() {
      window.parent.location.href = `//${location.host}/#/resetPassword?redirect_url=${this.$route.query.serviceURL}&platform_code=${this.$route.query.client_id}`
    },
    validatePhone() {
      let errorText = ''
      if (!this.phone) {
        errorText = '请输入手机号'
      } else if (!/^1\d{10}$/.test(this.phone)) {
        errorText = '手机号格式错误'
      }
      this.phoneError = errorText
      return !errorText
    },
    handlePhoneInput(v) {
      this.validatePhone()
    },
    validateSmsCode() {
      let errorText = ''
      if (!this.smsCode) {
        errorText = '请输入短信验证码'
      } else if (!/^[\d]{4}$/.test(this.smsCode)) {
        errorText = '短信验证码格式错误'
      }
      this.smsCodeError = errorText
      return !errorText
    },
    handleSmsCodeInput(v) {
      this.validateSmsCode()
    },
    handleSmsCodeKeyUp(e) {
      if (e.keyCode === 13) {
        this.handleLogin()
      }
    },
    handleImgCodeKeyUp(e) {
      if (e.keyCode === 13) {
        this.handleLogin()
      }
    },
    validateImgCode() {
      if (!this.showImgCode) {
        return true
      }
      let errorText = ''
      if (!this.imgCode) {
        errorText = '请输入图片验证码'
      } else if (!/^\d{4}$/.test(this.imgCode)) {
        errorText = '图片验证码格式错误'
      }
      this.imgCodeError = errorText
      return !errorText
    },
    handleImgCodeInput(v) {
      this.validateImgCode()
    },
    validateAccount() {
      let errorText = ''
      if (!this.accountName) {
        errorText = '请输入手机号/邮箱/用户名'
      } else {
        errorText = ''
      }
      this.accountError = errorText
      return !errorText
    },
    handleAccountInput(v) {
      this.validateAccount()
    },
    validatePassword() {
      let errorText = ''
      if (!this.password) {
        errorText = '请输入密码'
      } else {
        errorText = ''
      }
      this.passwordError = errorText
      return !errorText
    },
    handlePasswordInput(v) {
      this.validatePassword()
    },
    handlePasswordKeyUp(e) {
      if (e.keyCode === 13) {
        this.handleLogin()
      }
    },
    handleFieldChange(key, value) {},
    handleRememberChange(e) {
      this.rememberMe = e.target.checked
    },
    validate() {
      if (this.currentTab === '1') {
        return (
          this.validatePhone() &&
          this.validateSmsCode() &&
          this.validateImgCode()
        )
      }
      return (
        this.validateAccount() &&
        this.validatePassword() &&
        this.validateImgCode()
      )
    },
    handleLogin() {
      let params
      let platformCode = this.$route.query.client_id
      if (!this.validate()) {
        return
      }
      if (this.currentTab === '1') {
        params = {
          phone: this.phone.trim(),
          phoneCode: this.smsCode,
          platformCode,
          randCode: this.imgCode
        }
        api.getTicketBySmsCode(params).then(res => {
          if (res.code === 0) {
            let ticket = res.data.ticket

            session.saveTicket(ticket)
            this.getToken(ticket).then(resp => {
              this.loginSuccess(resp)
            })
          } else if (res.code !== 0) {
            this.refreshImgCode()
            if (res.code === 3158) {
              this.showQR()
              return
            }
            Message.error(res.msg)
            if (res.code === 3888) {
              this.showImgCode = true
              localStorage.setItem('showImgCode_mini', 'yes')
            }
          }
        })
      } else {
        params = {
          accountName: this.accountName.trim(),
          password: this.password,
          platformCode,
          serviceURL: this.$route.query.serviceURL || location.href,
          randCode: this.imgCode
        }
        if (!params.accountName) {
          this.accountError = '请输入手机号/邮箱/用户名'
          return
        }
        if (!params.password) {
          this.passwordError = '请输入密码'
          return
        }
        this.getTicket(params).then(res => {
          if (res.code === 0) {
            let ticket = res.data.ticket

            session.saveTicket(ticket)
            this.getToken(ticket).then(resp => {
              this.loginSuccess(resp)
            })
          } else if (res.code !== 0) {
            this.refreshImgCode()
            if (res.code === 3158) {
              this.showQR()
              return
            }
            Message.error(res.msg)
            if (res.code === 3888) {
              this.showImgCode = true
              localStorage.setItem('showImgCode_mini', 'yes')
            }
          }
        })
      }
      // 是否记住登录信息
      if (this.rememberMe) {
        this.remember(true)
      } else {
        this.remember(false)
      }
    },
    getTicket(params) {
      return api.getTicket(params)
    },

    getToken(ticket) {
      return api.getToken(ticket, {
        serviceURL: this.$route.query.redirect_url || location.href
      })
    },
    loginSuccess(resp) {
      if (resp.code === 0) {
        let token = resp.data.token || resp.data
        const rootDomain = env.getRootDomain()
        localStorage.removeItem('showImgCode_mini')
        session.saveToken(token)
        this.postMessageToParent({
          token,
          state: this.$route.query.state,
          redirect_uri: this.$route.query.redirect_uri,
          response: {
            token: token,
            data: resp.data,
          }
        })
        // 设置一个SHARE_BY_SSO到根域名的cookie，防止uamsdk将token清除
        setCookie(
          'SHARE_BY_SSO',
          Math.random()
            .toString(16)
            .substr(2) + '_session_state',
          0,
          '/',
          rootDomain
        )

        // this.syncLoginInfoToGangxin({ token })
      } else if (resp.code !== 0) {
        this.refreshImgCode()
        if (resp.code === 3304) {
          Message.error('登录过期，请重新登录')
        } else {
          Message.error(resp.msg)
        }
        if (resp.code === 3888) {
          this.showImgCode = true
          localStorage.setItem('showImgCode_mini', 'yes')
        }
      }
    },

    /**
     * 将登录信息同步到hbgangxin.cn
     * */
    syncLoginInfoToGangxin({ token }) {
      let hostname = location.hostname
      let env = ''
      switch (true) {
        case hostname.indexOf('stable-dev') !== -1:
          env = 'stable-dev.'
          break
        case hostname.indexOf('stable-test') !== -1:
          env = 'stable-test.'
          break
        case hostname.indexOf('test') !== -1:
          env = 'test.'
          break
        case hostname.indexOf('dev') !== -1:
          env = 'dev.'
          break
        default:
          env = ''
      }
      this.isLoginSuccess = true
      this.hbgangxinDomain = `//www.${env}hbgangxin.cn/syncLoginInfo.html?uam_biz_token=${token}`
    },
    showQR() {
      this.qrVisible = true
    },
    hideQR() {
      this.qrVisible = false
    },
    // 如果存在ticket，则获取ticket并自动登录
    autoLogin() {
      let ticket = session.getTicket()
      if (ticket) {
        Message.info('已有登录凭证，自动登录中...')
        this.getToken(ticket).then(res => {
          setTimeout(() => {
            this.loginSuccess(res)
          }, 2500)
        })
      }
    },
    doesUserExist() {
      let params = {
        phone: this.phone,
        noParamsKey: true
      }
      return api.doesUserExist(params)
    },
    handleSmsCodeClick() {
      return this.doesUserExist().then(res => {
        if (res.code !== 0) {
          return res;
        }
        if (res.data) {
          return this.getSmsCode();
        }
        res.code = 2000;
        this.phoneError = '手机号尚未注册'
        return res
      })
    },
    getSmsCode() {
      if (!this.validatePhone()) {
        return
      }
      return api
        .getLoginSmsCode({
          phone: this.phone
        })
        .then(res => {
          if (res.code === 0) {
            // this.$refs.smsCodeInput.focus()
          }
          return res
        })
    },
    remember(yes) {
      if (yes) {
        localStorage.setItem('sso_spa_login_mini_remember', 'yes')
        localStorage.setItem('sso_spa_login_mini_phone', this.phone)
        localStorage.setItem('sso_spa_login_mini_accountName', this.accountName)
        localStorage.setItem('sso_spa_login_mini_password', this.password)
      } else {
        localStorage.removeItem('sso_spa_login_mini_remember')
        localStorage.removeItem('sso_spa_login_mini_phone')
        localStorage.removeItem('sso_spa_login_mini_accountName')
        localStorage.removeItem('sso_spa_login_mini_password')
      }
    },
    listenMessage() {
      /**
       * 给window添加message事件监听，
       * 实现和父window的双向通信
       * @param e
       */
      window.addEventListener('message', e => {
        try {
          var data = JSON.parse(e.data).data
          var type = JSON.parse(e.data).type
        } catch (e) {
          console && console.error('JSON解析出错.')
          return
        }
        Message[type] instanceof Function && Message[type](data)
      })
    },
    postMessageToParent(data) {
      window.parent.postMessage(
        JSON.stringify({
          type: 'afterLogin',
          display: 'customIframe',
          data: {
            redirect_uri: data.redirect_uri,
            token: data.token,
            state: data.state,
            response: {
              data,
              token: data.token,
            }
          }
        }),
        '*'
      )
    }
  },
  mounted() {
    this.listenMessage()

    if (localStorage.getItem('sso_spa_login_mini_remember') === 'yes') {
      this.$refs.remember.checked = true
      this.rememberMe = true
      this.phone = localStorage.getItem('sso_spa_login_mini_phone')
      this.accountName = localStorage.getItem('sso_spa_login_mini_accountName')
      this.password = localStorage.getItem('sso_spa_login_mini_password')
    }

    this.autoLogin()
  },
  components: { Input, Button, Countdown }
}
</script>
<style lang="scss" scoped>
@import 'style.scss';
</style>
